import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1e606d9e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "main"
};
const _hoisted_2 = {
  class: "banner top-distance"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "com-div clearfix a-posion"
};
const _hoisted_6 = {
  class: "swiper-slide"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "mask"
};
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  class: "mask"
};
const _hoisted_11 = {
  class: "swiper-slide"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = {
  class: "mask"
};
const _hoisted_14 = {
  class: "fr banner-right"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "banner-top clearfix"
}, [/*#__PURE__*/_createElementVNode("p", {
  class: "fl"
}, "Goby")], -1));

const _hoisted_16 = {
  class: "banner-bot text-justify"
};
const _hoisted_17 = {
  class: "feature"
};
const _hoisted_18 = {
  class: "com-div"
};
const _hoisted_19 = {
  class: "com-title ac"
};
const _hoisted_20 = {
  class: "feature-blocks clearfix"
};
const _hoisted_21 = {
  class: "extension-section"
};
const _hoisted_22 = {
  class: "com-div ac"
};
const _hoisted_23 = {
  class: "com-title"
};
const _hoisted_24 = {
  class: "desc"
};
const _hoisted_25 = {
  class: "extension-list clearfix"
};
const _hoisted_26 = {
  class: "extension-item"
};
const _hoisted_27 = {
  class: "extension-logo"
};
const _hoisted_28 = ["src"];

const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "extension-name"
}, "FOFA", -1));

const _hoisted_30 = {
  class: "extension-author"
};
const _hoisted_31 = ["src"];

const _hoisted_32 = /*#__PURE__*/_createTextVNode("GobySec ");

const _hoisted_33 = {
  class: "cover"
};
const _hoisted_34 = {
  class: "extension-item"
};
const _hoisted_35 = {
  class: "extension-logo"
};
const _hoisted_36 = ["src"];

const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "extension-name"
}, "Elasticsearch未授权漏洞利用", -1));

const _hoisted_38 = {
  class: "extension-author"
};
const _hoisted_39 = ["src"];

const _hoisted_40 = /*#__PURE__*/_createTextVNode("Faz ");

const _hoisted_41 = {
  class: "cover"
};
const _hoisted_42 = {
  class: "extension-item"
};
const _hoisted_43 = {
  class: "extension-logo"
};
const _hoisted_44 = ["src"];

const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "extension-name"
}, "Xray", -1));

const _hoisted_46 = {
  class: "extension-author"
};
const _hoisted_47 = ["src"];

const _hoisted_48 = /*#__PURE__*/_createTextVNode("go0p ");

const _hoisted_49 = {
  class: "cover"
};
const _hoisted_50 = {
  class: "extension-item"
};
const _hoisted_51 = {
  class: "extension-logo"
};
const _hoisted_52 = ["src"];

const _hoisted_53 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "extension-name"
}, "ZBC", -1));

const _hoisted_54 = {
  class: "extension-author"
};
const _hoisted_55 = ["src"];

const _hoisted_56 = /*#__PURE__*/_createTextVNode("go0p ");

const _hoisted_57 = {
  class: "cover"
};
const _hoisted_58 = {
  class: "extension-item"
};
const _hoisted_59 = {
  class: "extension-logo"
};
const _hoisted_60 = ["src"];

const _hoisted_61 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "extension-name"
}, "Shodan", -1));

const _hoisted_62 = {
  class: "extension-author"
};
const _hoisted_63 = ["src"];

const _hoisted_64 = /*#__PURE__*/_createTextVNode("lidazhuang ");

const _hoisted_65 = {
  class: "cover"
};
const _hoisted_66 = {
  class: "extension-item"
};
const _hoisted_67 = {
  class: "extension-logo"
};
const _hoisted_68 = ["src"];

const _hoisted_69 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "extension-name"
}, "SubDomainsBrute", -1));

const _hoisted_70 = {
  class: "extension-author"
};
const _hoisted_71 = ["src"];

const _hoisted_72 = /*#__PURE__*/_createTextVNode("GobySec ");

const _hoisted_73 = {
  class: "cover"
};
const _hoisted_74 = {
  class: "extension-item"
};
const _hoisted_75 = {
  class: "extension-logo"
};
const _hoisted_76 = ["src"];

const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "extension-name"
}, "Hikvision", -1));

const _hoisted_78 = {
  class: "extension-author"
};
const _hoisted_79 = ["src"];

const _hoisted_80 = /*#__PURE__*/_createTextVNode("Vanilla ");

const _hoisted_81 = {
  class: "cover"
};
const _hoisted_82 = {
  class: "extension-item"
};
const _hoisted_83 = {
  class: "extension-logo"
};
const _hoisted_84 = ["src"];

const _hoisted_85 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "extension-name"
}, "Http", -1));

const _hoisted_86 = {
  class: "extension-author"
};
const _hoisted_87 = ["src"];

const _hoisted_88 = /*#__PURE__*/_createTextVNode("GobySec ");

const _hoisted_89 = {
  class: "cover"
};
const _hoisted_90 = {
  class: "extension-item"
};
const _hoisted_91 = {
  class: "extension-logo"
};
const _hoisted_92 = ["src"];

const _hoisted_93 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "extension-name"
}, "RapidDNS", -1));

const _hoisted_94 = {
  class: "extension-author"
};
const _hoisted_95 = ["src"];

const _hoisted_96 = /*#__PURE__*/_createTextVNode("RapidDNS ");

const _hoisted_97 = {
  class: "cover"
};
const _hoisted_98 = {
  class: "extension-item"
};
const _hoisted_99 = {
  class: "extension-logo"
};
const _hoisted_100 = ["src"];

const _hoisted_101 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "extension-name"
}, "Super Saiyan", -1));

const _hoisted_102 = {
  class: "extension-author"
};
const _hoisted_103 = ["src"];

const _hoisted_104 = /*#__PURE__*/_createTextVNode("c1o2a3 ");

const _hoisted_105 = {
  class: "cover"
};
const _hoisted_106 = {
  class: "more-btn",
  href: "javascript:;",
  target: "_self"
};

const _hoisted_107 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconrightarrow-01"
}, null, -1));

const _hoisted_108 = {
  class: "rich"
};
const _hoisted_109 = {
  class: "com-div pd"
};
const _hoisted_110 = {
  class: "com-title ac"
};
const _hoisted_111 = {
  class: "rich-blocks clearfix"
};
const _hoisted_112 = {
  class: "rich-item"
};
const _hoisted_113 = ["src"];
const _hoisted_114 = {
  class: "title"
};
const _hoisted_115 = {
  class: "desc text-justify"
};
const _hoisted_116 = {
  class: "rich-item"
};
const _hoisted_117 = ["src"];
const _hoisted_118 = {
  class: "title"
};
const _hoisted_119 = {
  class: "desc text-justify"
};
const _hoisted_120 = {
  class: "rich-item"
};
const _hoisted_121 = ["src"];
const _hoisted_122 = {
  class: "title"
};
const _hoisted_123 = {
  class: "desc text-justify"
};
const _hoisted_124 = {
  class: "rich-blocks clearfix"
};
const _hoisted_125 = {
  class: "rich-item"
};
const _hoisted_126 = ["src"];
const _hoisted_127 = {
  class: "title"
};
const _hoisted_128 = {
  class: "desc text-justify"
};
const _hoisted_129 = {
  class: "rich-item"
};
const _hoisted_130 = ["src"];
const _hoisted_131 = {
  class: "title"
};
const _hoisted_132 = {
  class: "desc text-justify"
};
const _hoisted_133 = {
  class: "mapping"
};
const _hoisted_134 = {
  class: "com-div ac"
};
const _hoisted_135 = {
  class: "com-title"
};
const _hoisted_136 = {
  class: "desc"
};
const _hoisted_137 = ["src"];
const _hoisted_138 = {
  class: "download-block",
  id: "dl"
};
const _hoisted_139 = {
  class: "com-div ac"
};
const _hoisted_140 = {
  class: "title"
};
const _hoisted_141 = {
  class: "desc"
};
const _hoisted_142 = {
  class: "sp0"
};
const _hoisted_143 = {
  class: "sp1"
};
const _hoisted_144 = {
  class: "clearfix"
};
const _hoisted_145 = {
  class: "fl ver-list al"
};
const _hoisted_146 = ["onClick"];

const _hoisted_147 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconzzhedie"
}, null, -1));

const _hoisted_148 = {
  class: "ver-list-main"
};
const _hoisted_149 = ["onClick"];

const _hoisted_150 = /*#__PURE__*/_createTextVNode("Windows (64-bit)");

const _hoisted_151 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconxiazai- ico"
}, null, -1));

const _hoisted_152 = [_hoisted_150, _hoisted_151];

const _hoisted_153 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_154 = ["onClick"];

const _hoisted_155 = /*#__PURE__*/_createTextVNode("MacOS ");

const _hoisted_156 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconxiazai- ico"
}, null, -1));

const _hoisted_157 = [_hoisted_155, _hoisted_156];

const _hoisted_158 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));

const _hoisted_159 = ["onClick"];

const _hoisted_160 = /*#__PURE__*/_createTextVNode("Linux");

const _hoisted_161 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconxiazai- ico"
}, null, -1));

const _hoisted_162 = [_hoisted_160, _hoisted_161];

const _hoisted_163 = /*#__PURE__*/_createStaticVNode("<div class=\"fr ver-sys clearfix\" data-v-1e606d9e><div class=\"win ac\" data-v-1e606d9e><i class=\"iconfont iconwindows\" data-v-1e606d9e></i> Windows </div><div class=\"mac ac\" data-v-1e606d9e><i class=\"iconfont iconpingguo\" data-v-1e606d9e></i> MAC </div><div class=\"lin\" data-v-1e606d9e> Linux </div></div>", 1);

const _hoisted_164 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont iconrightarrow-01"
}, null, -1));

const _hoisted_165 = {
  class: "clearfix index-bottom"
};
const _hoisted_166 = {
  href: "/updates?v=15"
};
const _hoisted_167 = {
  key: 0,
  class: "video-index"
};
const _hoisted_168 = {
  class: "modal-block"
};
const _hoisted_169 = {
  class: "modal-header"
};
const _hoisted_170 = {
  class: "header-main"
};
const _hoisted_171 = ["src"];
const _hoisted_172 = {
  class: "video-title"
};
const _hoisted_173 = {
  class: "modal-body"
};
const _hoisted_174 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_swiper_slide = _resolveComponent("swiper-slide");

  const _component_swiper = _resolveComponent("swiper");

  const _component_router_link = _resolveComponent("router-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    class: "left",
    src: require('@/assets/img/line-left.png')
  }, null, 8, _hoisted_3), _createElementVNode("img", {
    class: "right",
    src: require('@/assets/img/line-right.png')
  }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_createVNode(_component_swiper, {
    class: "swiper-container fl",
    modules: _ctx.modules,
    pagination: {
      clickable: true
    },
    "slides-per-view": 1
  }, {
    default: _withCtx(() => [_createVNode(_component_swiper_slide, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
        src: require('@/assets/img/about.png'),
        class: "banner-img"
      }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => _ctx.toggleVideoPopUp(1, '1', _ctx.$t('Presentation Video-Assets Mapping'))),
        class: "video-button showVideo"
      })])])]),
      _: 1
    }), _createVNode(_component_swiper_slide, null, {
      default: _withCtx(() => [_createElementVNode("img", {
        src: require('@/assets/img/session.jpg'),
        class: "banner-img"
      }, null, 8, _hoisted_9), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = $event => _ctx.toggleVideoPopUp(1, '1', _ctx.$t('Presentation Video-Session terminal'))),
        class: "video-button showVideo"
      })])]),
      _: 1
    }), _createVNode(_component_swiper_slide, null, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("img", {
        src: require('@/assets/img/loophole.png'),
        class: "banner-img"
      }, null, 8, _hoisted_12), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = $event => _ctx.toggleVideoPopUp(1, '1', _ctx.$t('Presentation Video-Vulnerability Scanning'))),
        class: "video-button showVideo"
      })])])]),
      _: 1
    })]),
    _: 1
  }, 8, ["modules"]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('The new generation of network security technology achieves rapid security emergency through the establishment of a complete asset database for the target.')), 1), _createElementVNode("a", {
    class: _normalizeClass(['download', _ctx.lang == 'en' ? 'download-en' : '']),
    href: "/#dl"
  }, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('Free Download')), 1)], 2), _createElementVNode("a", {
    href: "javascript:;",
    class: _normalizeClass(['download', 'downloadpay', _ctx.lang == 'en' ? 'download-en' : '']),
    onClick: _cache[3] || (_cache[3] = $event => _ctx.jump('/sale', 'paymentTopButtom'))
  }, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('Buy')), 1)], 2)])])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("What will you getting then?")), 1), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("Assets")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("Generate full assets database")), 1)]), _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("Enjoy")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("Built for security experts")), 1)]), _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(_ctx.$t("Vulnerabilities")), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("Fastest, check only potentially affected assets")), 1)])])])]), _createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("Extensible and customizable")), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("Want even more features? Goby has built-in expansion capabilities. Under the extension API blessing, asset Scanning, vulnerability scanning, themes can be customized or enhanced.")), 1), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_27, [_createElementVNode("img", {
    src: require('@/assets/img/fofa.png')
  }, null, 8, _hoisted_28)]), _hoisted_29, _createElementVNode("div", _hoisted_30, [_createElementVNode("img", {
    src: require('@/assets/img/GobySec.png')
  }, null, 8, _hoisted_31), _hoisted_32]), _createElementVNode("span", null, _toDisplayString(_ctx.$t("Tools")), 1)]), _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t("Extensions Info['FOFA is a powerful mapping tool for cyberspace assets.']")), 1)]), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_35, [_createElementVNode("img", {
    src: require('@/assets/img/Elasticsearch.png')
  }, null, 8, _hoisted_36)]), _hoisted_37, _createElementVNode("div", _hoisted_38, [_createElementVNode("img", {
    src: require('@/assets/img/Faz.png')
  }, null, 8, _hoisted_39), _hoisted_40]), _createElementVNode("span", null, _toDisplayString(_ctx.$t("Tools")), 1)]), _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.$t("Extensions Info['Elasticsearch unauthorized vulnerability exploit tool, and supports viewing the Indices information.']")), 1)]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_43, [_createElementVNode("img", {
    src: require('@/assets/img/Xray.png')
  }, null, 8, _hoisted_44)]), _hoisted_45, _createElementVNode("div", _hoisted_46, [_createElementVNode("img", {
    src: require('@/assets/img/go0p.png')
  }, null, 8, _hoisted_47), _hoisted_48]), _createElementVNode("span", null, _toDisplayString(_ctx.$t("Tools")), 1)]), _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t("Extensions Info['Xray is a web crawler tool.']")), 1)]), _createElementVNode("div", _hoisted_50, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_51, [_createElementVNode("img", {
    src: require('@/assets/img/ZBC.png')
  }, null, 8, _hoisted_52)]), _hoisted_53, _createElementVNode("div", _hoisted_54, [_createElementVNode("img", {
    src: require('@/assets/img/go0p.png')
  }, null, 8, _hoisted_55), _hoisted_56]), _createElementVNode("span", null, _toDisplayString(_ctx.$t("Tools")), 1)]), _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t("Extensions Info['Zoomeye、BinaryEdge、Censys API']")), 1)]), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_59, [_createElementVNode("img", {
    src: require('@/assets/img/Shodan.png')
  }, null, 8, _hoisted_60)]), _hoisted_61, _createElementVNode("div", _hoisted_62, [_createElementVNode("img", {
    src: require('@/assets/img/lidazhuang.png')
  }, null, 8, _hoisted_63), _hoisted_64]), _createElementVNode("span", null, _toDisplayString(_ctx.$t("Tools")), 1)]), _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.$t("Extensions Info['Query the IP and ports with Shodan, and support importing JSON files downloaded by Shodan.']")), 1)]), _createElementVNode("div", _hoisted_66, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_67, [_createElementVNode("img", {
    src: require('@/assets/img/SubDomainsBrute.png')
  }, null, 8, _hoisted_68)]), _hoisted_69, _createElementVNode("div", _hoisted_70, [_createElementVNode("img", {
    src: require('@/assets/img/GobySec.png')
  }, null, 8, _hoisted_71), _hoisted_72]), _createElementVNode("span", null, _toDisplayString(_ctx.$t("Tools")), 1)]), _createElementVNode("div", _hoisted_73, _toDisplayString(_ctx.$t("Extensions Info['Input the root domain, brute force subdomain.']")), 1)]), _createElementVNode("div", _hoisted_74, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_75, [_createElementVNode("img", {
    src: require('@/assets/img/hikvision.png')
  }, null, 8, _hoisted_76)]), _hoisted_77, _createElementVNode("div", _hoisted_78, [_createElementVNode("img", {
    src: require('@/assets/img/vanilla.png')
  }, null, 8, _hoisted_79), _hoisted_80]), _createElementVNode("span", null, _toDisplayString(_ctx.$t("Tools")), 1)]), _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.$t("Extensions Info['Hikvision vulnerability validation tool and returns a snapshot.']")), 1)]), _createElementVNode("div", _hoisted_82, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_83, [_createElementVNode("img", {
    src: require('@/assets/img/Http.png')
  }, null, 8, _hoisted_84)]), _hoisted_85, _createElementVNode("div", _hoisted_86, [_createElementVNode("img", {
    src: require('@/assets/img/GobySec.png')
  }, null, 8, _hoisted_87), _hoisted_88]), _createElementVNode("span", null, _toDisplayString(_ctx.$t("Tools")), 1)]), _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.$t("Extensions Info['Http repeater.']")), 1)]), _createElementVNode("div", _hoisted_90, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_91, [_createElementVNode("img", {
    src: require('@/assets/img/RapidDNS.png')
  }, null, 8, _hoisted_92)]), _hoisted_93, _createElementVNode("div", _hoisted_94, [_createElementVNode("img", {
    src: require('@/assets/img/RapidDNStx.png')
  }, null, 8, _hoisted_95), _hoisted_96]), _createElementVNode("span", null, _toDisplayString(_ctx.$t("Tools")), 1)]), _createElementVNode("div", _hoisted_97, _toDisplayString(_ctx.$t("Extensions Info['RapidDNS is a dns query tool which make querying subdomains or sites of a same ip easy!']")), 1)]), _createElementVNode("div", _hoisted_98, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_99, [_createElementVNode("img", {
    src: require('@/assets/img/Super Saiyan.png')
  }, null, 8, _hoisted_100)]), _hoisted_101, _createElementVNode("div", _hoisted_102, [_createElementVNode("img", {
    src: require('@/assets/img/c1o2a3.png')
  }, null, 8, _hoisted_103), _hoisted_104]), _createElementVNode("span", null, _toDisplayString(_ctx.$t("Themes")), 1)]), _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.$t("Extensions Info['Super Saiyan theme.']")), 1)])]), _createVNode(_component_router_link, {
    to: "/doc"
  }, {
    default: _withCtx(() => [_createElementVNode("a", _hoisted_106, [_createTextVNode(_toDisplayString(_ctx.$t("Learn more about extensions")), 1), _hoisted_107])]),
    _: 1
  })])]), _createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createElementVNode("div", _hoisted_110, _toDisplayString(_ctx.$t("Goby Professional Benefits")), 1), _createElementVNode("div", _hoisted_111, [_createElementVNode("div", _hoisted_112, [_createElementVNode("img", {
    src: require('@/assets/img/Asset Scanning.svg')
  }, null, 8, _hoisted_113), _createElementVNode("div", _hoisted_114, _toDisplayString(_ctx.$t("The richest device rule set")), 1), _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.$t("More than 100,000 rule identification engines are pre-set in Goby, which can identify and classify hardware equipment and software business system automatically and comprehensively analyze the business system that exists in a network. It currently supports more than 100,000 devices and business systems. Hardware coverage: network equipment, internet of things equipment, network security products, office equipment, etc. Software coverage: CRM, CMS, EMAIL, OA system, etc.")), 1)]), _createElementVNode("div", _hoisted_116, [_createElementVNode("img", {
    src: require('@/assets/img/Asset Classification.svg')
  }, null, 8, _hoisted_117), _createElementVNode("div", _hoisted_118, _toDisplayString(_ctx.$t("Most lightweight protocol identification")), 1), _createElementVNode("div", _hoisted_119, _toDisplayString(_ctx.$t("More than 200 protocol identification engines are pre-set in Goby, covering networking protocol, database protocol, IoT protocol, ICS protocol, etc. Through very lightweight Iperf, it can quickly analyze the protocol information corresponding to the port, with fast speed and little impact on target equipment.")), 1)]), _createElementVNode("div", _hoisted_120, [_createElementVNode("img", {
    src: require('@/assets/img/Product Identification.svg')
  }, null, 8, _hoisted_121), _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.$t("Port grouping based on rich attack and defense experience")), 1), _createElementVNode("div", _hoisted_123, _toDisplayString(_ctx.$t("Our security team summarized the port grouping of different scenarios through the front-line security practice to ensure most efficient output. It is not feasible for penetration test personnel to scan ports 1-65535 on a large network for full coverage, therefore port grouping is particularly important. Currently we have screened over 300 ports for scanning to ensure the highest input-output ratio.")), 1)])]), _createElementVNode("div", _hoisted_124, [_createElementVNode("div", _hoisted_125, [_createElementVNode("img", {
    src: require('@/assets/img/Vendor Identification.svg')
  }, null, 8, _hoisted_126), _createElementVNode("div", _hoisted_127, _toDisplayString(_ctx.$t("Vulnerability framework based on daily community updates")), 1), _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.$t("The vulnerability engine with the most effective attack is pre-set in Goby, covering the critical vulnerabilities such as Weblogic and Tomcat. A large amount of vulnerability information is generated from the Internet (such as CVE) , which are screened and updated on daily basis to identify the ones that would be used for real attacks. Goby also provides a customizable vulnerability checking framework. Security practitioners around the world are motivated to contribute POC to ensure continuous emergency response capability. Meanwhile, We believe that the real-effect-based checks are more valuable than version-based comparisons.")), 1)]), _createElementVNode("div", _hoisted_129, [_createElementVNode("img", {
    src: require('@/assets/img/Vulnerability Scanning.svg')
  }, null, 8, _hoisted_130), _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.$t("The most comprehensive default password detection")), 1), _createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.$t("Almost any device will have a default account or even a backdoor account, and the traditional brute force attack mode is not optimal. Pre-set account information of more than 1,000 devices are pre-set in Goby for targeted inspection, ensuring the accuracy and efficiency of risk identification. Goby has built-in brute force attack testing of custom dictionaries for various protocols.")), 1)])])])]), _createElementVNode("div", _hoisted_133, [_createElementVNode("div", _hoisted_134, [_createElementVNode("div", _hoisted_135, _toDisplayString(_ctx.$t("Meet Cyberspace Mapping")), 1), _createElementVNode("div", _hoisted_136, _toDisplayString(_ctx.$t("The core idea of cyberspace mapping technology is a knowledge base established by first analyzing the rules of the target network IT assets, which is a new technology that can respond in the shortest time in the event of a security incident. Different from traditional port scanning and vulnerability scanning, Goby only deals with certain affected areas in case of a vulnerability incident, resulting in quickest response with the least impact on the target network.")), 1), _createElementVNode("img", {
    src: require('@/assets/img/mapping.png')
  }, null, 8, _hoisted_137)])]), _createElementVNode("div", _hoisted_138, [_createElementVNode("div", _hoisted_139, [_createElementVNode("div", _hoisted_140, _toDisplayString(_ctx.$t("Download Goby")), 1), _createElementVNode("div", _hoisted_141, [_createTextVNode(_toDisplayString(_ctx.$t("The current Beta of Goby is")), 1), _createElementVNode("span", _hoisted_142, _toDisplayString(_ctx.version_base), 1), _createElementVNode("span", _hoisted_143, _toDisplayString(_ctx.version), 1)]), _createElementVNode("div", _hoisted_144, [_createElementVNode("div", _hoisted_145, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.versionsList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass([{
        active: _ctx.activeVerison == item.version
      }, "ver-list-item"])
    }, [_createElementVNode("div", {
      class: "ver-list-top",
      onClick: $event => _ctx.toggleShow(item.version)
    }, [_createTextVNode(_toDisplayString(item.version_base) + " (" + _toDisplayString(item.version) + ") • " + _toDisplayString(item.date) + " ", 1), _hoisted_147], 8, _hoisted_146), _createElementVNode("div", _hoisted_148, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: $event => _ctx.down(item.win_download_url)
    }, _hoisted_152, 8, _hoisted_149), _hoisted_153, _createElementVNode("a", {
      href: "javascript:;",
      onClick: $event => _ctx.down(item.mac_download_url)
    }, _hoisted_157, 8, _hoisted_154), _hoisted_158, _createElementVNode("a", {
      href: "javascript:;",
      onClick: $event => _ctx.down(item.linux_download_url)
    }, _hoisted_162, 8, _hoisted_159)])], 2);
  }), 128))]), _hoisted_163]), _createElementVNode("div", {
    onClick: _cache[4] || (_cache[4] = $event => _ctx.jump('/sale', 'paymentButtonBottom')),
    class: "payment-version-click"
  }, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Payment Version')), 1), _hoisted_164]), _createElementVNode("div", _hoisted_165, [_createTextVNode(_toDisplayString(_ctx.$t("More downloads and documentation can be found on the")), 1), _createElementVNode("a", _hoisted_166, "  " + _toDisplayString(_ctx.$t("updates page.")), 1)])])]), _ctx.showVideo ? (_openBlock(), _createElementBlock("div", _hoisted_167, [_createElementVNode("div", _hoisted_168, [_createElementVNode("div", _hoisted_169, [_createElementVNode("div", _hoisted_170, [_createElementVNode("img", {
    class: "logo_2",
    src: require('@/assets/img/logo_2.svg')
  }, null, 8, _hoisted_171), _createElementVNode("span", _hoisted_172, _toDisplayString(_ctx.videoTitle), 1)]), _createElementVNode("button", {
    type: "button",
    class: "close modal-close",
    onClick: _cache[5] || (_cache[5] = $event => _ctx.toggleVideoPopUp(0, '1', ''))
  }, "×")]), _createElementVNode("div", _hoisted_173, [_createElementVNode("video", {
    id: "movie",
    src: _ctx.videoSrcMap[_ctx.videoSrc],
    autoplay: "",
    controls: "",
    loop: "",
    style: {
      "width": "100%"
    }
  }, null, 8, _hoisted_174)])])])) : _createCommentVNode("", true)]);
}